import ModalForm from '../../../shared/components/modal-form';

export default class BookmarkAddForm extends ModalForm {
  constructor() {
    super(...arguments);

    this.bindEvents();
  }

  handleModalHide(event) {
    // Only reload the window if the modal has been closed,
    // not any component within itself (like the datepicker)
    if (this.formWasSuccessful && event.target === this.$element[0]) {
      window.Turbolinks.reload({keepScrollPosition: true});
    }
  }

  handleFormSuccess() {
    this.formWasSuccessful = true;
    this.$element.modal('hide');
  }

  handleModalShow() {
    setTimeout(() => this.focusInput(), 0);

    super.handleModalShow();
  }

  focusInput() {
    this.$element.find('.bookmarkAddForm-input').focus();
  }
}
